import React from "react";
import { motion } from "framer-motion";
import { Zap, Search, ShieldCheck, TrendingUp, Check } from "lucide-react";
import { fadeUp, Section } from "./shared";

const HERO_BULLETS = ["Get your funding report", "See a best-match lender", "Link open banking", "Get funded"];
const SOFT_SEARCH_POINTS = ["Checks public records", "Makes a soft credit search", "Clarity without credit impact", "Shows you where you'll approve"];
const STAT_CARDS = [
  { value: "93%", label: "Approval rate" },
  { value: "6h", label: "Fastest payout" },
  { value: "100+", label: "Lenders compete" },
];

export const WhyItWorks = () => (
  <Section id="why" className="pb-24 sm:pb-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-5">
        <motion.div variants={fadeUp} className="md:col-span-7 rounded-3xl bg-[#052F24] text-[#F6F5F2] p-9 sm:p-12 relative overflow-hidden grain">
          <Zap className="text-[#DFFF00] mb-6" size={30} />
          <h3 className="font-display font-extrabold text-3xl sm:text-4xl tracking-tight leading-tight mb-4">
            The fastest, most private way to fund your business in the UK.
          </h3>
          <p className="font-light text-[#F6F5F2]/70 max-w-md">
            Funds in as little as 6 hours — or take your time. Over 100 lenders compete for your application.
          </p>
          <div className="mt-9 flex flex-wrap gap-3">
            {HERO_BULLETS.map((s, i) => (
              <span key={s} className="text-xs font-semibold rounded-full border border-[#F6F5F2]/25 px-3.5 py-2">
                {i + 1}. {s}
              </span>
            ))}
          </div>
        </motion.div>

        <motion.div variants={fadeUp} custom={1} className="md:col-span-5 rounded-3xl bg-white border border-[#E5E5E0] p-9 sm:p-12">
          <Search className="mb-6 text-[#052F24]" size={28} />
          <h3 className="font-display font-extrabold text-2xl tracking-tight mb-4">Soft search only</h3>
          <ul className="space-y-3 font-light text-[#052F24]/70">
            {SOFT_SEARCH_POINTS.map((t) => (
              <li key={t} className="flex items-center gap-2.5">
                <Check size={17} className="text-[#052F24]" /> {t}
              </li>
            ))}
          </ul>
        </motion.div>

        <motion.div variants={fadeUp} custom={2} className="md:col-span-5 rounded-3xl bg-[#DFFF00] p-9 sm:p-12">
          <ShieldCheck className="mb-6 text-[#052F24]" size={28} />
          <h3 className="font-display font-extrabold text-2xl tracking-tight mb-4">No spammers, ever</h3>
          <p className="font-light text-[#052F24]/80">
            We don't sell your data or fire off multiple applications. We pair you with a single, top UK lender and give you a concierge through to funding.
          </p>
        </motion.div>

        <motion.div variants={fadeUp} custom={3} className="md:col-span-7 rounded-3xl bg-white border border-[#E5E5E0] p-9 sm:p-12 flex flex-col justify-between">
          <TrendingUp className="text-[#052F24]" size={28} />
          <div className="flex items-end gap-8 mt-8">
            {STAT_CARDS.map((s) => (
              <div key={s.label}>
                <div className="font-display font-extrabold text-5xl tracking-tighter">{s.value}</div>
                <p className="text-sm text-[#052F24]/55 mt-1">{s.label}</p>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </div>
  </Section>
);
